import {
  createPatientEvent,
  createScripturePatient,
  getPatientEventByCharge,
  getPatientEventByPatientId,
  getScriptsureIframe,
  updatePatientEvent,
  updatePatientFacilityEvent,
} from './backendHelper'
import { toast } from 'react-toastify'

export async function getPatientEventHistory(patientId) {
  if (!patientId) {
    return []
  }
  try {
    let res = await getPatientEventByPatientId(patientId)
    return Array.isArray(res) ? res : []
  } catch (e) {
    console.error(e)
    return []
  }
}

export async function getPatientEventWithCharge(chargeId) {
  if (!chargeId) {
    return null
  }
  try {
    return await getPatientEventByCharge(chargeId)
  } catch (e) {
    console.error(e)
    return null
  }
}

export async function createNewPatientEvent(payload) {
  try {
    return await createPatientEvent(payload)
  } catch (e) {
    console.error(e)
    return false
  }
}

export async function overridePatientEvent(payload) {
  try {
    let createdId = await updatePatientEvent(payload)
    return Boolean(createdId)
  } catch (e) {
    console.error(e)
    return false
  }
}

export async function updatePatientEventFacilityDetails(payload) {
  try {
    let createdId = await updatePatientFacilityEvent({ ...payload, type: 'FACILITY' })
    return Boolean(createdId)
  } catch (e) {
    console.error(e)
    return false
  }
}

async function createNewScriptsurePatient({ patientId }) {
  try {
    let createdId = await createScripturePatient(patientId)
    return createdId
  } catch (e) {
    console.error(e)
    return null
  }
}

async function getScripturePatientIframe({ patientId }) {
  try {
    let url = await getScriptsureIframe(patientId)
    return url
  } catch (e) {
    console.error(e)
    return ''
  }
}

export async function openScripture(patientId, onUrlFail) {
  try {
    const scriptPat = await createNewScriptsurePatient({
      patientId: patientId,
    })
    if (!scriptPat?.patientId) {
      toast.error('Patient demographics insufficient')
      return
    }
    const scriptURL = await getScripturePatientIframe({
      patientId: patientId,
    })
    if (!(scriptURL && scriptURL.startsWith('https'))) {
      toast.error('Failed to open ScriptSure data')
      return
    }
    const tab = window.open(scriptURL, '_blank')
    if (!tab) {
      onUrlFail()
    }
  } catch (e) {
    console.error(e)
  }
}
